module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile-updated":"Profile updated !","not-email":"Please enter a valid mail"},"fr":{"profile-updated":"Profil mis à jour !","not-email":"Veuillez saisir une adresse mail valide"}}')
  delete Component.options._Ctor
}
